import { BadWordsErrorMessage, HasNoBadWords, } from '@ally/use-validation';
export const validator = (badWords) => (value = '', isName = false) => HasNoBadWords(isName)(value, { badWords });
export const errorMessage = BadWordsErrorMessage;
//# sourceMappingURL=invalidStrings.js.map